module.exports = __webpack_public_path__ + "img/ot-slp_eth_usdc-usdc.83dedd2e.png";